// @flow
import { createRoot } from 'react-dom/client';
import React from 'react';
import MapInteractiveStates from './react/MapInteractiveStates';

document.querySelectorAll('.map-is').forEach(($list) => {
  const $script = document.getElementById('mapInteractiveData');

  if ($script) {
    const data = JSON.parse($script.textContent);
    const root = createRoot($list);
    root.render(<MapInteractiveStates {...data} />);
  }
});
